export interface BankFormConfig {
    id: string;
    countryLabel: string;
    Label: string;
    incorrectSelect: string;
    incorrectLabel: string;
    placeholder?: string;
}

// eslint-disable-next-line @typescript-eslint/array-type
export const bankFormConfigs: BankFormConfig[] = [
    {
        id: 'pago_movil',
        countryLabel: 'Código de Banco en Venezuela',
        Label: 'Número de Teléfono',
        incorrectSelect: 'Debe seleccionar un código de banco',
        incorrectLabel: 'El número de teléfono es incorrecto'
    },
    {
        id: 'banco_bol',
        countryLabel: 'Nombre de Banco en Bolivia',
        Label: 'Número de Cuenta',
        incorrectSelect: 'Debe seleccionar un banco',
        incorrectLabel: 'El número de cuenta es incorrecto, debe ser por ejemplo: 0453132124',
        placeholder: 'Por ejemplo: 0453132124'
    }
];
